import { toNumber } from '@freelancer/utils';
import { MembershipSaleItemAjax } from './membership-sale.backend-model';
import { MembershipSale } from './membership-sale.model';

export function transformMembershipSaleItem(
  sale: MembershipSaleItemAjax,
  authUid: string,
): MembershipSale {
  return {
    id: toNumber(authUid),
    couponCode: sale.couponCode,
    timeStart: sale.timeStart * 1000,
    timeEnd: sale.timeEnd * 1000,
    color: sale.color,
    heroImageSourceUrl: sale.heroImageSourceUrl,
    mobileHeroImageSourceUrl: sale.mobileHeroImageSourceUrl,
    heroTitle: sale.heroTitle,
    // we do use <br> tags in the hero subtitles for membership sales
    heroSubtitle: sale.heroSubtitle
      .replace(/&lt;br\/&gt;/g, '<br/>')
      .replace(/&lt;br&gt;/g, '<br>'),
    dashboardImageSourceUrl: sale.dashboardImageSourceUrl,
    dashboardTitle: sale.dashboardTitle,
    dashboardSubtitle: sale.dashboardSubtitle,
  };
}
